function chanceAction(probability: number, action: () => void) {
  if (probability > 1 || probability < 0)
    throw new Error('please provide a probability between 0 and 1');
  if (Math.random() <= probability) return action();
  return;
}

export { chanceAction };
